import React, { useEffect } from 'react'
import { useNewTranslation } from 'hooks'
import { useSelector, useDispatch } from 'react-redux'
import { clearConfirmPopup, selectConFirmPopup } from 'state/confirmPopup'
import _ from 'lodash'
import Modal from 'particles/Modal'

export enum RecordChangesKey {
    IS_CAMPAIGN_VALUE_CHANGE = 'isCampaignValueChange',
}

interface CompareChangesPopupProps {
    initialData: Record<string, any>
    compareData: Record<string, any>
    recordChangesKey: RecordChangesKey
    onConfirm?: VoidFunction
}

const CompareChangesPopup: React.FC<CompareChangesPopupProps> = ({
    children,
    initialData,
    compareData,
    recordChangesKey,
    onConfirm,
}) => {
    const confirmPopupConfig = useSelector(selectConFirmPopup)
    const [t] = useNewTranslation()
    const dispatch = useDispatch()
    useEffect(() => {
        const isEqual = _.isEqual(initialData, compareData)
        if (!isEqual) {
            localStorage.setItem(recordChangesKey, 'yes')
        } else {
            localStorage.removeItem(recordChangesKey)
        }
    }, [initialData, compareData])
    return (
        <>
            {children}
            {confirmPopupConfig.show && (
                <Modal
                    title={t('modalWindow.confirmationMessage.goBackSaveChangesTitle')}
                    subtext={t('modalWindow.confirmationMessage.goBackSaveChangesSubtitle')}
                    secondaryButtonProps={{
                        label: t('button.cancel'),
                    }}
                    primaryButtonProps={{
                        label: t('button.yesGoBack'),
                    }}
                    size="s"
                    isClosable={false}
                    onConfirm={() => {
                        onConfirm?.()
                        if (confirmPopupConfig.onConfirm) {
                            confirmPopupConfig.onConfirm()
                        }
                        localStorage.removeItem(recordChangesKey)
                        dispatch(clearConfirmPopup())
                    }}
                    onClose={() => {
                        if (confirmPopupConfig.onClose) {
                            confirmPopupConfig.onClose()
                        }
                        dispatch(clearConfirmPopup())
                    }}
                />
            )}
        </>
    )
}
export default CompareChangesPopup
